import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FreudMessage, FreudMessageService } from '@freud-ds/web-components';
import { TranslateService } from '@ngx-translate/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { EventsService } from 'app/services/events.service';

@Component({
	selector: 'appointment-delete-recurrency-modal',
	templateUrl: './appointment-delete-recurrency-modal.component.html',
	styleUrls: ['./appointment-delete-recurrency-modal.component.scss'],
})
export class AppointmentDeleteRecurrencyModalComponent {
	@Input()
	isOpen;

	@Input()
	appointmentId;

	@Output()
	onClose = new EventEmitter<void>();

	@Output()
	onCancel = new EventEmitter<void>();

	removeRange = 'current';
	isLoading = false;
	constructor(
		public eventsService: EventsService,
		public translate: TranslateService,
		public messageService: FreudMessageService,
		public atService: ActionTrackerService
	) {}

	cancelInvites() {
		this.isLoading = true;
		this.eventsService
			.cancelRecurrencyInvites(this.appointmentId, this.removeRange)
			.toPromise()
			.then(() => {
				this.trackCancel('success');
				const message: FreudMessage = {
					severity: 'success',
					summary: this.translate.instant(
						this.removeRange === 'current'
							? 'RECURRENCY_ATTEMPT.SUCCESS_CANCEL_INVITE'
							: 'RECURRENCY_ATTEMPT.SUCCESS_CANCEL_ALL_INVITE'
					),
					detail: null,
				};
				this.messageService.add(message);
				this.onCancel.emit();
			})
			.catch(() => {
				this.trackCancel('error');
				const message: FreudMessage = {
					severity: 'error',
					summary: this.translate.instant(
						this.removeRange === 'current'
							? 'RECURRENCY_ATTEMPT.ERROR_CANCEL_INVITE'
							: 'RECURRENCY_ATTEMPT.ERROR_CANCEL_ALL_INVITE'
					),
					detail: null,
				};
				this.messageService.add(message);
			})
			.finally(() => {
				this.isLoading = false;
				this.onClose.emit();
			});
	}

	trackCancel(action: string) {
		this.atService.eventTracker(
			SCOPE_TYPE.Appointment,
			SUBSCOPE_TYPE.Invite,
			this.removeRange === 'current'
				? ITEM_TYPE.CancelSingle
				: ITEM_TYPE.CancelAll,
			action === 'success' ? INTERACTION_TYPE.Success : INTERACTION_TYPE.Error,
			{}
		);
	}
}
